import Confirm from './Confirm';
import Review from './Review';
import StatementsWizard from './Wizard';

export { Confirm, Review };

export default StatementsWizard;
